import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import ButtonLink from '../../../../../../../../components/Buttons/ButtonLink/ButtonLink'
import { CONTENT_WINDOWS } from '../../constants'

import './ClubSummaryHeader.scss'

const ClubSummaryHeader = ({ activeWindow, setActiveWindow }) => {
    const intl = useIntl()

    const links = [
        /*
        remove comment and add other options 
        { text: intl.formatMessage({ id: 'userProfile.cinestarClub.coupons.title' }), value: CONTENT_WINDOWS.COUPONS },
        { text: intl.formatMessage({ id: 'userProfile.cinestarClub.rewards.title' }), value: CONTENT_WINDOWS.REWARDS },
        */
        {
            text: intl.formatMessage({ id: 'userProfile.cinestarClub.pointsOverview.title' }),
            value: CONTENT_WINDOWS.OVERVIEW,
        },
    ]

    return (
        <Container fluid className="club-summary-header d-flex">
            {links.map(({ text, value }) => (
                <ButtonLink
                    key={value}
                    className={`px-0 py-1 ${activeWindow === value && 'selected'}`}
                    onClick={() => setActiveWindow(value)}
                >
                    {text}
                </ButtonLink>
            ))}
        </Container>
    )
}

export default ClubSummaryHeader
